// General
import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import {Helmet} from 'react-helmet';
import { Provider } from 'react-redux';
import store from './store';

// HOC
import ScrollToTop from './higher-order-components/ScrollToTop';

// Assets
import './App.css';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Speaker from './pages/Speaker';
import SpeakersBureau from './pages/SpeakersBureau';
import Privacy from './pages/Privacy';
import NotFound from './pages/NotFound';

// Functions


// Components

class App extends Component {
  render() {
    return (
      <BrowserRouter>
      <ScrollToTop>
      <div className="App">
        <Helmet>
          <title>Candid Goat | Custom Tech Solutions for Small Businesses</title>
          <meta name="description" content="From websites to CRMs to everything in between, Candid Goat will chew through your tech tasks so that you don't have to." />
        </Helmet>
        <Switch>
          <Route exact path='/' component={Home}/>
          <Route path='/about' component={About}/>
          <Route path='/services' component={Services}/>
          <Route path='/speaker' component={Speaker}/>
          <Route path='/speakers-bureau' component={SpeakersBureau}/>
          <Route path='/privacy' component={Privacy} />
          <Route component={NotFound}/>
        </Switch>
      </div>
      </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js